import { createStructuredSelector } from 'reselect'

const initialState = {
  tableParams: {},
  isModalOpen: false,
  selectedBatteries: [],
  selectedRow: [],
  auxiliarSelectedRow: null,
  hideActionBar: false
}

export const notReportingBatteriesDetailsReducer = (state = initialState, { payload, type } = {}) => {
  switch (type) {
    case setTableParams.type:
      return {
        ...state,
        tableParams: payload
      }
    case setModalIsOpen.type:
      return {
        ...state,
        isModalOpen: payload
      }
    case setSelectedBatteries.type:
      return {
        ...state,
        selectedBatteries: payload
      }
    case setSelectedRow.type:
      return {
        ...state,
        selectedRow: payload
      }
    case setHideActionBar.type:
      return {
        ...state,
        hideActionBar: payload
      }
    case setAuxiliarSelectedRow.type:
      return {
        ...state,
        auxiliarSelectedRow: payload
      }
    case resetTableSelection.type:
      return {
        ...state,
        isModalOpen: false,
        selectedRow: [],
        auxiliarSelectedRow: [],
        hideActionBar: true
      }
    default:
      return state
  }
}
notReportingBatteriesDetailsReducer.slice = 'not-reporting-batteries-details'

export const setTableParams = (tableParams = {}) => ({ type: setTableParams.type, payload: tableParams })
setTableParams.type = 'not-reporting-batteries-details/setTableParams'

export const setModalIsOpen = (isModalOpen = false) => ({ type: setModalIsOpen.type, payload: isModalOpen })
setModalIsOpen.type = 'not-reporting-batteries-details/setModalIsOpen'

export const setSelectedBatteries = (selectedBatteries = []) => ({ type: setSelectedBatteries.type, payload: selectedBatteries })
setSelectedBatteries.type = 'not-reporting-batteries-details/setSelectedBatteries'

export const setSelectedRow = (selectedRow = []) => ({ type: setSelectedRow.type, payload: selectedRow })
setSelectedRow.type = 'not-reporting-batteries-details/setSelectedRow'

export const setAuxiliarSelectedRow = (auxiliarSelectedRow = []) => ({ type: setAuxiliarSelectedRow.type, payload: auxiliarSelectedRow })
setAuxiliarSelectedRow.type = 'not-reporting-batteries-details/setAuxiliarSelectedRow'

export const setHideActionBar = (hideActionBar = false) => ({ type: setHideActionBar.type, payload: hideActionBar })
setHideActionBar.type = 'not-reporting-batteries-details/setHideActionBar'

export const resetTableSelection = () => ({ type: resetTableSelection.type })
resetTableSelection.type = 'not-reporting-batteries-details/resetTableSelection'

export const getTableParams = state => state[notReportingBatteriesDetailsReducer.slice].tableParams
export const getModalIsOpen = state => state[notReportingBatteriesDetailsReducer.slice].isModalOpen
export const getSelectedBatteries = state => state[notReportingBatteriesDetailsReducer.slice].selectedBatteries
export const getSelectedRow = state => state[notReportingBatteriesDetailsReducer.slice].selectedRow
export const getAuxiliarSelectedRow = state => state[notReportingBatteriesDetailsReducer.slice].auxiliarSelectedRow
export const getHideActionBar = state => state[notReportingBatteriesDetailsReducer.slice].hideActionBar

export const getDetailsDataTableSelectors = createStructuredSelector({
  tableParams: getTableParams,
  isModalOpen: getModalIsOpen,
  selectedBatteries: getSelectedBatteries,
  selectedRow: getSelectedRow,
  auxiliarSelectedRow: getAuxiliarSelectedRow,
  hideActionBar: getHideActionBar
})